import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import api from "./api";

// Persistido en user.settings (campo explícito en SettingsReq, ver server.py) vía el endpoint
// PUT /settings ya existente — nunca bloquea el tour si la llamada falla.
export const markTourSeen = () => api.put("/settings", { tour_seen: true }).catch(() => {});
export const markChannelTourSeen = () => api.put("/settings", { channel_tour_seen: true }).catch(() => {});

// Tour corto (3 pasos) anclado a los MISMOS data-testid que ya usan los tests — nada de
// selectores nuevos. Empieza en la pantalla de "Mis canales", que es lo primero que ve
// cualquier usuario con al menos un canal ya creado (ver condición de disparo en Builder.jsx).
export function startProductTour(t, { onDone } = {}) {
  const d = driver({
    showProgress: true,
    progressText: "{{current}}/{{total}}",
    animate: true,
    overlayColor: "rgba(15, 23, 42, 0.7)",
    prevBtnText: t("tour.prev"),
    nextBtnText: t("tour.next"),
    doneBtnText: t("tour.done"),
    onDestroyed: () => { markTourSeen(); onDone && onDone(); },
    steps: [
      {
        element: '[data-testid="create-channel-btn"]',
        popover: { title: t("tour.step1Title"), description: t("tour.step1Desc"), side: "bottom" },
      },
      {
        element: '[data-testid^="channel-card-"]',
        popover: { title: t("tour.step2Title"), description: t("tour.step2Desc"), side: "bottom" },
      },
      {
        element: '[data-testid="profile-menu-trigger"]',
        popover: { title: t("tour.step3Title"), description: t("tour.step3Desc"), side: "left" },
      },
    ],
  });
  d.drive();
  return d;
}

// Tour para la pantalla de un canal (lista de vídeos), anclado a los mismos data-testid que ya
// usan los tests. Estos botones/pestañas están siempre en el DOM tanto si el canal tiene vídeos
// como si está vacío (a diferencia de la grilla de vídeos), así que el tour nunca apunta a un
// elemento que pueda no existir. Cada pestaña del switcher (vídeos/calendario/recomendados/
// YouTube) tiene su propio paso, en vez de agruparlas en uno solo.
export function startChannelTour(t, { onDone } = {}) {
  const d = driver({
    showProgress: true,
    progressText: "{{current}}/{{total}}",
    animate: true,
    overlayColor: "rgba(15, 23, 42, 0.7)",
    prevBtnText: t("tour.prev"),
    nextBtnText: t("tour.next"),
    doneBtnText: t("tour.done"),
    onDestroyed: () => { markChannelTourSeen(); onDone && onDone(); },
    steps: [
      {
        element: '[data-testid="oneclick-open-button"]',
        popover: { title: t("tour.channelStep1Title"), description: t("tour.channelStep1Desc"), side: "bottom" },
      },
      {
        element: '[data-testid="new-video-button"]',
        popover: { title: t("tour.channelStep2Title"), description: t("tour.channelStep2Desc"), side: "bottom" },
      },
      {
        element: '[data-testid="section-videos"]',
        popover: { title: t("tour.channelStepVideosTitle"), description: t("tour.channelStepVideosDesc"), side: "bottom" },
      },
      {
        element: '[data-testid="section-calendario"]',
        popover: { title: t("tour.channelStep3Title"), description: t("tour.channelStep3Desc"), side: "bottom" },
      },
      {
        element: '[data-testid="section-recomendados"]',
        popover: { title: t("tour.channelStepRecoTitle"), description: t("tour.channelStepRecoDesc"), side: "bottom" },
      },
      {
        element: '[data-testid="section-youtube"]',
        popover: { title: t("tour.channelStepYoutubeTitle"), description: t("tour.channelStepYoutubeDesc"), side: "bottom" },
      },
      {
        element: '[data-testid="channel-config-btn"]',
        popover: { title: t("tour.channelStep4Title"), description: t("tour.channelStep4Desc"), side: "left" },
      },
    ],
  });
  d.drive();
  return d;
}
